import type { VPCPainReliever, VPCGainCreator } from '@ispot/shared'

/** Get all painIds a reliever addresses (backward compat with single-link records) */
export function getRelieverPainIds(r: VPCPainReliever): string[] {
  if (r.painIds && r.painIds.length > 0) return r.painIds
  return [r.painId]
}

/** Get all gainIds a creator addresses */
export function getCreatorGainIds(c: VPCGainCreator): string[] {
  if (c.gainIds && c.gainIds.length > 0) return c.gainIds
  return [c.gainId]
}

let _idCounter = 0
export function nextId(prefix: string) {
  return `${prefix}_${Date.now()}_${++_idCounter}`
}
